import { create } from 'zustand';

// 模型信息接口
interface ModalInfo {
    name: string;
    code: string;
}

// 类型定义
type CounterStore = {
    open: boolean;
    pageOpen: boolean;
    mobileSidebarOpen: boolean;
    setOpen: (newVal: boolean) => void;
    setPageOpen: (newVal: boolean) => void;
    setMobileSidebarOpen: (newVal: boolean) => void;
    modal: string;
    setModal: (newVal: string) => void;
    // 深度思考状态
    isDeepThinking: boolean;
    setIsDeepThinking: (newVal: boolean) => void;
    // 模型列表缓存
    modalList: ModalInfo[];
    setModalList: (newVal: ModalInfo[]) => void;
    modalListLastFetch: number;
    setModalListLastFetch: (timestamp: number) => void;
};

const useCounterStore = create<CounterStore>((set) => ({
    // 从 localStorage 初始化
    open: localStorage.getItem('open') !== 'false',
    pageOpen: localStorage.getItem('pageOpen') !== 'false',
    mobileSidebarOpen: false,

    // 安全的更新方法
    setOpen: (newVal) => {
        set({ open: newVal });
        localStorage.setItem('open', newVal.toString());
    },

    setPageOpen: (newVal) => {
        set({ pageOpen: newVal });
        localStorage.setItem('pageOpen', newVal.toString());
    },
    setMobileSidebarOpen: (newVal) => {
        set({ mobileSidebarOpen: newVal });
    },
    modal: localStorage.getItem('modal') || 'bee-thinking-v1',
    setModal: (newVal :string) => {
        set({ modal: newVal });
        localStorage.setItem('modal', newVal.toString());
    },
    // 深度思考状态初始化（从 localStorage 读取）
    isDeepThinking: localStorage.getItem('isDeepThinking') === 'true',
    setIsDeepThinking: (newVal: boolean) => {
        set({ isDeepThinking: newVal });
        localStorage.setItem('isDeepThinking', newVal.toString());
    },

    // 模型列表缓存初始化
    modalList: [],
    setModalList: (newVal: ModalInfo[]) => {
        set({ modalList: newVal });
    },
    modalListLastFetch: 0,
    setModalListLastFetch: (timestamp: number) => {
        set({ modalListLastFetch: timestamp });
    },
}));

// 添加全局状态监听器
let isListenerAdded = false;

if (!isListenerAdded) {
    // 监听所有状态变化
    useCounterStore.subscribe((state) => {
        // 当 open 变化时同步更新 localStorage
        if (state.open !== (localStorage.getItem('open') === 'true')) {
            localStorage.setItem('open', state.open.toString());
        }

        // 当 pageOpen 变化时同步更新 localStorage
        if (state.pageOpen !== (localStorage.getItem('pageOpen') === 'true')) {
            localStorage.setItem('pageOpen', state.pageOpen.toString());
        }

        // 当 isDeepThinking 变化时同步更新 localStorage
        if (state.isDeepThinking !== (localStorage.getItem('isDeepThinking') === 'true')) {
            localStorage.setItem('isDeepThinking', state.isDeepThinking.toString());
        }
    });

    isListenerAdded = true; // 防止重复添加
}

export default useCounterStore;
